import { HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {of, Observable} from 'rxjs';
import {map} from "rxjs/operators";
import {ApiService} from '../api/api.service';
import moment from 'moment-timezone';
import {MultiEditServiceInterface} from './people.service.interfaces';
import { PermissionsService } from '../permissions/permissions.service';
@Injectable({
  providedIn: 'root'
})
export class PeopleService {
  people_path = 'people/organisation';
  rehireStatusMap = {
    'Target': 0,
    'Potential target': 1,
    'No target': 2,
    'Unknown': 3,
  }
  optInMap = {
    'Candidate': 3,
    'Potential candidate': 4,
    'Ex-employee': 0
  }

  selectedPeople: any[] = [];
  constructor(private apiService: ApiService,
              private permission: PermissionsService) {

   }

  getPeople(searchOptions?:any, sortOptions?:any, rowsPerPage=5, pageNumber=1, filterOptions?:any, status?: any, selectedPeople?: any): Observable<any>{
    let params = new HttpParams();
    if (rowsPerPage){
      params = params.set('limit', String(rowsPerPage));
      params = params.set('offset', String((pageNumber-1)*rowsPerPage))
    }
    if (sortOptions && sortOptions !== 'grouped' && sortOptions !=='-grouped'){
        params = params.set('sort', sortOptions);
    }
    if (searchOptions) {
      searchOptions.forEach(element => {
        params = params.append(element.key, element.value);
      });
    }
    if(filterOptions && filterOptions['filterBy'] && filterOptions['filter'] != 'All'){
      let utcStart = moment(filterOptions['start_date']).utc();
      let utcEnd = moment(filterOptions['end_date']).utc();
      params = params.set('filter', filterOptions['filterBy']?.toLowerCase()?.replace(' ', '_'))
                .set('start_date', utcStart.format())
                .set('end_date', utcEnd.format());
    }
    if (status) {
      params = params.append('status', status);
    }
    if (sortOptions && selectedPeople && sortOptions.match('-?grouped')) {
      params = params.append('selected_people', selectedPeople)

      if(pageNumber > 1 && sortOptions === 'grouped') {
        const offsetCorrection = selectedPeople.split(',').length
        params = params.set('offset', String((pageNumber-1)*rowsPerPage - offsetCorrection))
      }
    }
    if(filterOptions && filterOptions['department_id'] && filterOptions['department_category_id']){
      params = params.append('department_id', filterOptions['department_id']).append('department_category_id',filterOptions['department_category_id'] )
    }
    const path = this.people_path + '/all';
    return this.apiService.get(path, {params});
  }

  deprecatedGetTalentPool(searchOptions?:any, sortOptions?:any, rowsPerPage=0, pageNumber=1, filterOptions?:any): Observable<any>{
    let params = new HttpParams();
    if (rowsPerPage){
      params = params.set('limit', String(rowsPerPage));
      params = params.set('offset', String((pageNumber-1)*rowsPerPage))
    }
    if (sortOptions && sortOptions !== 'grouped' && sortOptions !== '-grouped') {
      params = params.set('sort', sortOptions);
    }
    if (searchOptions) {
      searchOptions.forEach(element => {
        params = params.append(element.key, element.value);
      });
    }
    if (Object.keys(filterOptions).length > 0) {
      if(filterOptions['filterBy'] && filterOptions['filter'] != 'All'){
        let utcStart = moment(filterOptions['start_date']).utc();
        let utcEnd = moment(filterOptions['end_date']).utc();
        params = params.set('filter', filterOptions['filterBy']?.toLowerCase()?.replace(' ', '_'))
                  .set('start_date', utcStart.format())
                  .set('end_date', utcEnd.format());
      }
      if(filterOptions['statusOption']?.length){
        params = params.set('rehire_status', filterOptions['statusOption']?.map(status=>this.rehireStatusMap[status]).join(','));
      }
      if( filterOptions['department_id'] && filterOptions['department_category_id']){
        params = params.append('department_id', filterOptions['department_id']).append('department_category_id',filterOptions['department_category_id'] )
      }
      params = params.set('people', filterOptions['checkboxOption'][0]);
    }
    const path = this.people_path + '/talent-pool';
    return this.apiService.get(path, {params});
  }

    getTalentPool(searchOptions?:any, sortOptions?:any, rowsPerPage=0, pageNumber=1, filterOptions?:any): Observable<any>{
    let params = new HttpParams();
    if (rowsPerPage){
      params = params.set('limit', String(rowsPerPage));
      params = params.set('offset', String((pageNumber-1)*rowsPerPage))
    }
    if (sortOptions && sortOptions !== 'grouped' && sortOptions !== '-grouped') {
      params = params.set('sort', sortOptions);
    }
    if (searchOptions) {
      searchOptions.forEach(element => {
        params = params.append(element.key, element.value);
      });
    }
    if (Object.keys(filterOptions).length > 0) {
      if(filterOptions['filter']){
        let utcStart = moment(filterOptions['start_date']).utc();
        let utcEnd = moment(filterOptions['end_date']).utc();
        params = params.set('start_date', utcStart.format()).set('end_date', utcEnd.format());
      }
      if(filterOptions['statusOption']?.length){
        params = params.set('rehire_status', filterOptions['statusOption']?.map(status=>this.rehireStatusMap[status]).join(','));
      }
      if ( filterOptions['optInOption']?.length) {
        params = params.set('opt_in_as', filterOptions['optInOption']?.map(status=>this.optInMap[status]).join(','));
      }
      if (filterOptions['location']) {
        params = params.set('person_location', filterOptions['location']);
        if (filterOptions['distance']) {
          params = params.set('distance', filterOptions['distance']);
        }
      }
    }
    const path = this.people_path + '/talent-pool';
    return this.apiService.get(path, {params});
  }

  updatePeople(params:MultiEditServiceInterface): Observable<any> {
    let uids = [];
    uids = params?.data?.map (d => ({uid: d.uid}));
    let requestData = {'status': params?.status, 'uids': uids,...params?.department_and_dates}
    const endpoint = 'people/organisation/profile';
    return this.apiService.patch(endpoint, requestData).pipe(map(res => res['data']));
  }

  deprecated_updatePeople(data, status,department_and_dates): Observable<any> {
    let uids = data.map (d => ({uid: d.uid}));
    let requestData = {'status': status, 'uids': uids,...department_and_dates}
    const endpoint = 'people/organisation/profile';
    return this.apiService.patch(endpoint, requestData).pipe(map(res => res['data']));
  }

  updatePeopleAll(status, searchOptions?:any, sortOptions?:any, rowsPerPage=5, pageNumber=1, filterOptions?:any, status_filter?: any, selectedPeople?: any, department_and_dates?: any): Observable<any> {
    const endpoint = 'people/organisation/profile/all';
    const isFeatureActive = this.permission.isFeatureActivated('ent-10167-add-target-status-to-multi-edit');
    // If feature flag is OFF
    if (!isFeatureActive) {
      const requestData: any = {'status': status};
      return this.apiService.patch(endpoint, requestData).pipe(map(res => res['data']));
    }

    let requestData: any = {'status': status};

    if (department_and_dates) {
      // Include all fields (department, rehire_status, employment dates)
      requestData = {...requestData, ...department_and_dates};
    }
    let params = new HttpParams();
    if (rowsPerPage){
      params = params.set('limit', String(rowsPerPage));
      params = params.set('offset', String((pageNumber-1)*rowsPerPage))
    }
    if (sortOptions && sortOptions !== 'grouped' && sortOptions !=='-grouped'){
        params = params.set('sort', sortOptions);
    }
    if (searchOptions) {
      searchOptions.forEach(element => {
        params = params.append(element.key, element.value);
      });
    }
    if(filterOptions && filterOptions['filterBy'] && filterOptions['filter'] != 'All'){
      let utcStart = moment(filterOptions['start_date']).utc();
      let utcEnd = moment(filterOptions['end_date']).utc();
      params = params.set('filter', filterOptions['filterBy']?.toLowerCase()?.replace(' ', '_'))
                .set('start_date', utcStart.format())
                .set('end_date', utcEnd.format());
    }
    if (status_filter) {
      params = params.append('status', status_filter);
    }
    if (sortOptions && selectedPeople && sortOptions.match('-?grouped')) {
      params = params.append('selected_people', selectedPeople)

      if(pageNumber > 1 && sortOptions === 'grouped') {
        const offsetCorrection = selectedPeople.split(',').length
        params = params.set('offset', String((pageNumber-1)*rowsPerPage - offsetCorrection))
      }
    }
    if(filterOptions && filterOptions['department_id'] && filterOptions['department_category_id']){
      params = params.append('department_id', filterOptions['department_id']).append('department_category_id',filterOptions['department_category_id'] )
    }

    const queryString = params.toString() ? `?${params.toString()}` : '';

    return this.apiService.patch(`${endpoint}${queryString}`, requestData).pipe(map(res => res['data']));
  }

  updateTalentPoolAll(status, searchOptions?:any, sortOptions?:any, rowsPerPage=0, pageNumber=1, filterOptions?:any, department_and_dates?: any): Observable<any> {
    const endpoint = 'people/organisation/talent-pool/all';
    const isFeatureActive = this.permission.isFeatureActivated('ent-10167-add-target-status-to-multi-edit');

    // If feature flag is OFF
    if (!isFeatureActive) {
      const requestData: any = {'status': status};
      return this.apiService.patch(endpoint, requestData).pipe(map(res => res['data']));
    }

    // Feature flag ON: Use new behavior with queryParams and department_and_dates
    let requestData: any = {'status': status};

    if (department_and_dates) {
      // Include all fields (department, rehire_status, employment dates)
      requestData = {...requestData, ...department_and_dates};
    }
    let params = new HttpParams();
    if (rowsPerPage){
      params = params.set('limit', String(rowsPerPage));
      params = params.set('offset', String((pageNumber-1)*rowsPerPage))
    }
    if (sortOptions && sortOptions !== 'grouped' && sortOptions !== '-grouped') {
      params = params.set('sort', sortOptions);
    }
    if (searchOptions) {
      searchOptions.forEach(element => {
        params = params.append(element.key, element.value);
      });
    }
    if (filterOptions && Object.keys(filterOptions).length > 0) {
      if(filterOptions['filter']){
        let utcStart = moment(filterOptions['start_date']).utc();
        let utcEnd = moment(filterOptions['end_date']).utc();
        params = params.set('start_date', utcStart.format()).set('end_date', utcEnd.format());
      }
      if(filterOptions['statusOption']?.length){
        params = params.set('rehire_status', filterOptions['statusOption']?.map(status=>this.rehireStatusMap[status]).join(','));
      }
      if ( filterOptions['optInOption']?.length) {
        params = params.set('opt_in_as', filterOptions['optInOption']?.map(status=>this.optInMap[status]).join(','));
      }
      if (filterOptions['location']) {
        params = params.set('person_location', filterOptions['location']);
        if (filterOptions['distance']) {
          params = params.set('distance', filterOptions['distance']);
        }
      }
    }
    // Build query string for filters
    const queryString = params.toString() ? `?${params.toString()}` : '';

    return this.apiService.patch(`${endpoint}${queryString}`, requestData).pipe(map(res => res['data']));
  }
  validatePeopleProfiles(data): Observable<any> {
    const endpoint = 'people/organisation/profile/validate/';
    return this.apiService.post(endpoint, data).pipe(map(res => res['data']));
  }

  getTalentPoolGeneratedReports(): Observable<any>{
    const endpoint = 'people/organisation/talent-pool/report/generated-reports';
    return this.apiService.get(endpoint).pipe(map(res => res['data']));
  }

  getGeneratedReports(): Observable<any>{
    const endpoint = 'report/generated-reports';
    return this.apiService.get(endpoint).pipe(map(res => res['data']));
  }

  generateTalentPoolReport(data): Observable<any>{
    const endpoint = 'people/organisation/profile/report/export';
    return this.apiService.post(endpoint, data).pipe(map(res => res['data']));
  }

  retryTalentPoolReport(data): Observable<any>{
    const endpoint = 'people/organisation/profile/report/export';
    return this.apiService.patch(endpoint, data).pipe(map(res => res['data']));
  }
}
